import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  employeeNames: string[]
}

function EmployeesList({ employeeNames }: Props) {
  return (
    <Box
      gap="s4"
      flexDirection="column"
      alignItems="flexStart"
      maxHeight="s240"
      overflowY="scroll"
      gapDivider
    >
      {employeeNames.map((employeeName) => (
        <Text.Normal ellipsis key={employeeName}>
          {employeeName}
        </Text.Normal>
      ))}
    </Box>
  )
}

export default observer(EmployeesList)
